import { Component, OnInit, Inject, HostListener, ViewChild, ElementRef } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { MatSnackBar, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CountyRecord } from 'src/app/models/countyRecord';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  @ViewChild('nextBtn', {static: true, read: ElementRef}) private nextBtn: ElementRef;
  dt: CountyRecord;
  index: number;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ds: DataService,
    private sbar: MatSnackBar) { }

  ngOnInit() {

    if (this.data.data) {
      this.index = this.data.index;
      this.dt = this.data.data[this.index];
      console.log(this.dt);
    }
  }

  onNoteChange(event) {
    this.nextBtn.nativeElement.focus();
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {

    switch (event.code) {
      case 'ArrowRight':
        this.onNext(1);
        break;
      case 'ArrowLeft':
        this.onNext(-1);
        break;

      default:
        break;
    }
  }

  onChange(event: MatCheckboxChange) {

    this.data.data[this.index].Exclude = event.checked;

  }

  onUpdate(event: boolean) {

    if (event) {

      this.getList().forEach(n => {
        this.data.data = this.data.data.filter(x => {
          return x.FromParties[0] !== n;
        });
      });

      if (this.index >= this.data.data.length) {
        this.index = this.data.data.length - 1;
      }

      this.dt.UpdateList.push('exclude');

      this.ds.UpdateRecords([this.dt], this.data.tabIndex)
      .subscribe(obs => {
        this.dt = this.data.data[this.index];
      });
    }
  }

  getList(): string[] {
    const elist = [];

    this.data.data.forEach(e => {
      if (e.Exclude) {
        elist.push(e.FromParties[0]);
      }
    });

    return elist;
  }

  onDelete() {
    const vert: MatSnackBarVerticalPosition = 'top';

    const sRef = this.sbar.open('Confirm that you want to delete.', 'Confirm', {
      duration: 4000,
      verticalPosition: vert
    });

    sRef.onAction().subscribe(() => {
      this.ds.DeleteRecord(this.dt, this.data.tabIndex)
      .subscribe(n => {
        this.dt = this.data.data[this.index];
      });
    });
  }

  onNext(event) {
    this.index = this.index + event;

    if (this.index < 0) {
      this.index = this.data.data.length - 1;
    } else if (this.index === this.data.data.length) {
      this.index = 0;
    }

    this.dt = this.data.data[this.index];
  }
}
